export default __webpack_public_path__ + "static/media/profesora.f1c28f25.png";